import { render, staticRenderFns } from "./employee-permissions.vue?vue&type=template&id=48dceb61&scoped=true"
import script from "./employee-permissions.vue?vue&type=script&lang=js"
export * from "./employee-permissions.vue?vue&type=script&lang=js"
import style0 from "./employee-permissions.vue?vue&type=style&index=0&id=48dceb61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dceb61",
  null
  
)

/* custom blocks */
import block0 from "./employee-permissions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports